export const getTenant = (bayonConfig) => {
  const isMultitenancy = bayonConfig.multitenancy?.enabled;
  const tenantName = isMultitenancy
    ? bayonConfig.multitenancy?.tenantName
    : bayonConfig.keycloak.realm;
  return { isMultitenancy, tenantName };
};
